import _ from 'lodash';
import globalStore from '$$globalStore';
import projectsModel from '$$projectModel';
import timeIntervals from '$$helpers/timeIntervals';
import helperDate from '$$helpers/dateFormats';

const getDefaultWorkHoursPerDay = dayHours => {
  const hoursArray = timeIntervals.getHoursArrayByIntervalArray(dayHours, helperDate.getHoursArrayByUserTimeFormat());

  return hoursArray.length / 2;
};

export default (taskId, ganttId) => {
  const task = globalStore.getters['tasksModel/getTaskByGanttId'](+ganttId, +taskId);

  if (!task) {
    return [];
  }

  const projectConfig = projectsModel.getProjectConfig(+ganttId);
  const taskResources = globalStore.getters['tasksModel/getResourcesForTask'](+ganttId, +taskId);
  const projectResources = globalStore.getters['resourcesModel/getResourcesByProjectIdForUI'](+ganttId);

  const filteredProjectResources = projectConfig.isJira ? projectResources.filter(resource => !resource.userId) : projectResources;
  const workDaysCount = _.floor((task.duration / 60) / getDefaultWorkHoursPerDay(projectConfig.durationData.showTime), 2);

  const preparedResources = filteredProjectResources.map(resource => {
    const taskResourceData = taskResources.find(taskResource => taskResource.resource_id === resource.id);

    return {
      resource_id: resource.id,
      type: resource.type,
      taskType: task.type,
      userId: resource.userId, // todo: user_id
      selected: !!taskResourceData,
      picture: resource.picture,
      name: resource.name,
      value: taskResourceData && !_.isNil(taskResourceData.value) ? taskResourceData.value : 0,
      valuePerDay: 0,
      workDaysCount,
      customDaysCount: taskResourceData ? taskResourceData.custom_days.length : 0,
    };
  });

  return _.orderBy(preparedResources, ['selected', 'name'], ['desc', 'asc']);
};
